<template>
  <v-autocomplete
    :value="value"
    :items="items"
    :loading="loading"
    :disabled="loading"
    v-on="$listeners"
    item-text="name"
    item-value="id"
    label="Publicación"
    name="publication"
    validation="required"
  ></v-autocomplete>
</template>

<script>
import api from '@/modules/milenium/api';

export default {
  props: {
    value: {
      type: Number,
    },
  },
  data() {
    return {
      items: [],
      loading: false,
    };
  },
  async mounted() {
    this.loading = true;
    try {
      this.items = await api.getPublications();
    } catch (error) {
      console.error('Error loading milenium publications', error);
    } finally {
      this.loading = false;
    }
  },
};
</script>
